import {
  hasConsentFor,
  HUBSPOT_IFRAME_ID,
  isHubspotChatLoaded,
  NODE_ENV
} from '../helpers'
import { useMount } from './use-mount'

export const useTrackingScripts = () => {
  useMount(() => {
    if (NODE_ENV === 'development') return

    const initializeGoogleTagManager = () => {
      const gtmScript = document.createElement('script')

      // microsoft clarity & the hubspot chat comes from here
      gtmScript.id = 'gtm-script' // prevent duplicate insertion
      gtmScript.async = true
      gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-5XN2BQ7'

      gtmScript.onload = () => {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        })
      }

      document.head.appendChild(gtmScript)
    }

    const initializeBingUET = () => {
      const bingScript = document.createElement('script')

      bingScript.id = 'bing-script' // prevent duplicate insertion
      bingScript.async = true
      bingScript.src = '//bat.bing.com/bat.js'

      bingScript.onload = () => {
        if (!window.UET) return

        window.uetq = window.uetq || []
        window.uetq.push('consent', 'default', {
          ad_storage: 'denied'
        })

        if (hasConsentFor('targeting')) {
          const o = { ti: '97118862', enableAutoSpaTracking: true }
          o.q = window.uetq
          window.uetq = new window.UET(o)
          window.uetq.push('pageLoad')
          window.uetq.push('consent', 'update', {
            ad_storage: 'granted'
          })
        }
      }

      document.head.appendChild(bingScript)
    }

    const initializeCDNCookieScript = () => {
      const cdnCookieScript = document.createElement('script')

      cdnCookieScript.id = 'cdn-cookie-script' // prevent duplicate insertion
      cdnCookieScript.src =
        '//cdn.cookie-script.com/s/5529df8370726e18cebb9caaa73ce2fd.js'
      cdnCookieScript.type = 'text/javascript'

      document.head.appendChild(cdnCookieScript)
    }

    initializeGoogleTagManager()
    initializeBingUET()
    initializeCDNCookieScript()
  })

  useMount(() => {
    const observer = new MutationObserver(() => {
      if (isHubspotChatLoaded()) {
        const hubspotChat = document.getElementById(HUBSPOT_IFRAME_ID)

        // hide the hubspot chat as soon as it appears in the dom
        // it gets displayed via the use-hubspot-chat.js hook for trial partners
        hubspotChat.style.display = 'none'
        hubspotChat.style.visibility = 'hidden'

        // eslint-disable-next-line

        observer.disconnect()
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })

    return () => observer.disconnect()
  })
}
